// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1YJ4-","dragIcon":"SortableItem_dragIcon__2SLMu","disabled":"SortableItem_disabled__1LIq3"};